var exports = {
  "zr": "x93eb46d8--33a942--root",
  "su": "x93eb46d8--33a942--icon-wrapper",
  "mP": "x93eb46d8--33a942--caret-left",
  "X4": "x93eb46d8--33a942--caret-right",
};

module.exports = exports;
